// .ENV - Staging
// export const backendURL = "http://doodlebluelive.com";
// export const baseUrl = `${backendURL}:2301/api/v1`;
// export const baseUrlcustomer = `${backendURL}:2302/api/v1`;
// export const baseUrlLocation = `${backendURL}:2304/api/v1`;
// export const baseUrlNotification = `${backendURL}:2305/api/v1`;
// export const baseUrlWarehouse = `${backendURL}:2303/api/v1`;
// export const baseID = 3257;
// export const MSMEID = 3835;

// .ENV - pre-production
// export const backendURL = "https://apidev.digigrain.in";
// export const baseUrl = `${backendURL}/user/api/v1`;
// export const baseUrlcustomer = `${backendURL}/vcm/api/v1`;
// export const baseUrlLocation = `${backendURL}/supplier/api/v1`;
// export const baseUrlNotification = `${backendURL}/notification/api/v1`;
// export const baseUrlWarehouse = `${backendURL}/warehouse/api/v1`;
// export const baseID = 2556;
// export const MSMEID = 3835;

// .ENV - production
// export const backendURL = "https://api.digigrain.in";
// export const baseUrl = `${backendURL}/user/api/v1`;
// export const baseUrlcustomer = `${backendURL}/vcm/api/v1`;
// export const baseUrlLocation = `${backendURL}/supplier/api/v1`;
// export const baseUrlNotification = `${backendURL}/notification/api/v1`;
// export const baseUrlWarehouse = `${backendURL}/warehouse/api/v1`;
// export const baseID = 2556;
// export const MSMEID = 3835;

// .ENV
// Accessing environment variables
export const backendURL = process.env.REACT_APP_BACKEND_URL;
export const baseUrl = process.env.REACT_APP_BASE_URL;
export const baseUrlcustomer = process.env.REACT_APP_BASE_URL_CUSTOMER;
export const baseUrlLocation = process.env.REACT_APP_BASE_URL_LOCATION;
export const baseUrlNotification = process.env.REACT_APP_BASE_URL_NOTIFICATION;
export const baseUrlWarehouse = process.env.REACT_APP_BASE_URL_WAREHOUSE;
export const baseUrlCog = process.env.REACT_APP_BASE_URL_COG;
export const baseUrlAgreement = process.env.REACT_APP_BASE_URL_AGREEMENT
export const baseUrlPayment = process.env.REACT_APP_BASE_URL_PAYMENT;
export const baseID = process.env.REACT_APP_BASE_ID;
export const MSMEID = process.env.REACT_APP_MSME_ID;
export const TDS = process.env.REACT_APP_TDS_ID;
export const GST = process.env.REACT_APP_GST_ID;
export const TAC = process.env.REACT_APP_TAC_ID;
export const TERMS = process.env.REACT_APP_TERMS_ID;
export const LOCATION = process.env.REACT_APP_LOCATION_ID;


// user
export const endpoints = {
  auth: {
    LOGIN_MOBILE_NUMBER: `${baseUrl}/users/loginOTP`,
    LOGIN_EMAIL: `${baseUrl}/users/loginPassoword`,
    RESET_PASSWORD: `${baseUrl}/users/resetPassword`,
    LOGOUT : `${baseUrl}/users/logOut`,
    UPDATE_PASSWORD: `${baseUrl}/users/updatePassword`,
    FORGET_PASSWORD: `${baseUrl}/users/forgotPassword`,
    GET_USER: `${baseUrl}/users/getAllProfileInfo`,
    VERIFY_OTP: `${baseUrl}/users/verifyLoginOTP`,
    CCG_Addendum: `${baseUrlcustomer}/addendum/CC/addedumStatusUpdate`,
    CCG_PROPOSAL_DETAIL: `${baseUrlcustomer}/contract/getDetails`,
    CCG_APPROVAL_STATUS: `${baseUrlcustomer}/contentChange/ccApproval/check`,
    CCG_PROPOSAL_STATUS: `${baseUrlcustomer}/checkCCApproval`,
    CCG_Approval: `${baseUrlcustomer}/ccApproval`,
    CCG_AGREEMENT_DATA: `${baseUrlcustomer}/contentChange/ccApproval`,
    CCG_ADDENDUM_STATUS: `${baseUrlcustomer}/addendum/checkCCApproval`,
  },
  customer: {
    MSME_REGISTRATION: `${baseUrlcustomer}/companyStatusPdfGenerator/create`,
    PROFILE_AADHAR_NUMBER: `${baseUrlcustomer}/verification/get-aadhar-details`,
    PROFILE_PAN_NUMBER: `${baseUrlcustomer}/verification/get-pan-details`,
    CUSTOMER_ONBOARD: `${baseUrl}/customer/onboard`,
    CUSTOMER_SEND_OTP: `${baseUrl}/otp/send`,
    CUSTOMER_IS_EXIST: `${baseUrl}/customer/isExist`,
    AP_IS_EXIST : `${baseUrl}/authorizedPersonSupplier/isExist`,
    VENDOR_IS_EXIST : `${baseUrl}/vendor/isExist`,
    CUSTOMER_VERIFY_OTP: `${baseUrl}/otp/validate`,
    CUSTOMER_VERIFY_OTP_RELEASE: `${baseUrl}/otp/release-customer/send`,
    Customer_Contract_Create: `${baseUrlcustomer}/contract/create`,
    CUSTOMER_CONTRACT_VERIFYOTP: `${baseUrlcustomer}/contract/verifyOTP`,
    Customer_Purchase_Order: `${baseUrlcustomer}/customer-proposals/list`,
    Proposal_order_Approved: `${baseUrlcustomer}/proposals/approveRequest?id=`,
    Proposal_order_Create: `${baseUrlcustomer}/proposals/create`,
    DELETE_ACCOUNT: `${baseUrl}/customer/delete`,
    AUTHORIZED_PERSON_LIST: `${baseUrl}/customer/list`,
    REQUIRED_COMMODITY_LIST: `${baseUrl}/commodity/list`,
    VARIETY_LIST: `${baseUrl}/variety/list`,
    REQUEST_TO_COMPLETE_PROFILE: `${baseUrlcustomer}/profleCompleteSendMail`,
    UPLOAD_ADDTIONAL_DOCUMENT: `${baseUrlcustomer}/contract/updateDocument`,
    NOTIFICATION_REUPLOAD_DOCUMENT: `${baseUrlcustomer}/contract/reupdateDocument`,
    Document_Aggreement: `${baseUrlcustomer}/contract/list`,
    STORAGE_LIST: `${baseUrlcustomer}/contract/Storage/list`,
    VIEW_QUALITY_PARAMETER: `${baseUrl}/document/get`,
    CUSTOMER_CARE_DETAILS: `${baseUrl}/customerCareDetails/get`,
    ADDENDUM_UPDATE: `${baseUrlcustomer}/addendum/update`,
    ADD_KNOWN_SUPPLIER: `${baseUrl}/customer/addKnownSupplier`,
    GET_AADHAR_ENTITY_NAME: `${baseUrlcustomer}/verification/get-gst-details`,
    CREATE_REQUEST_LOCATION: `${baseUrl}/requestLocation/create`,
    PAN_IMAGE_EXTRACTION: `${baseUrlcustomer}/imageExtraction`,
    RELEASE_MODULE_LIST: `${baseUrlcustomer}/releaseRequest/list`,
    ALLTRANSACTION_NEW_API: `${baseUrlcustomer}/depositAndReleaseList`,
    RELEASE_ORDER_LIST: `${baseUrlcustomer}/releaseOrder/list`,
    GET_RELEASE_MODULE_BY_ID: `${baseUrlcustomer}/releaseRequest/get`,
    CREATE_RELEASE_REQUEST: `${baseUrlcustomer}/releaseRequest/create`,
    EDIT_RELEASE_REQUEST: `${baseUrlcustomer}/releaseRequest/update`,
    GET_RELEASE_REQUEST_DATA: `${baseUrlcustomer}/contract/list`,
    GET_CONTRACT_BY_ID: `${baseUrlcustomer}/contract/get`,
    GET_RELEASE_ORDER: `${baseUrlcustomer}/releaseOrder/list`,
    GET_RELEASE_ORDER_BY_ID: `${baseUrlcustomer}/releaseOrder/get`,
    GET_RELEASE_REQUEST_BY_ID: `${baseUrlcustomer}/releaseUpdateByRO/get`,
    COMMODITY_RELEASE: `${baseUrlcustomer}/commodityRelease/create`,
    COMMODITY_RELEASE_LIST: `${baseUrlcustomer}/commodityRelease/list`,
    COMMODITY_RELEASE_UPDATE: `${baseUrlcustomer}/commodityRelease/update`,
    RELEASE_ORDER: `${baseUrlcustomer}/releaseOrder/create`,
    RELEASE_ORDER_NEW: `${baseUrlcustomer}/commodityRelease/AddAuthPerson`,
    RELEASE_ORDER_UPDATE: `${baseUrlcustomer}/releaseOrder/update`,
    AUTHORIZED_USER_LIST: `${baseUrl}/users/list`,
    AUTHORIZED_USER_LIST_NEW: `${baseUrlcustomer}/Auth_person/list`,
    AGREEMENT_LIST_ITEM: `${baseUrlAgreement}/agreementTemplate/list`,
    RELEASE_PDF_LIST: `${baseUrlcustomer}/releaseOrder/documents/list`,
    RELEASE_PDF_LIST_BY_ID: `${baseUrlcustomer}/releaseUpdate/documents/list`,
    CREATE_AGREEMENT_AMEND: `${baseUrlcustomer}/contract/agreementAmend`,
    ACCEPT_AGREMENT: `${baseUrlcustomer}/contract/agreementAgree`,
    GET_PAYMENTS_DETAILS_AMOUNT: `${baseUrlPayment}/paymentDetails/create`,
    GET_RELEASE_REQUEST_PDF_DETAILS: `${baseUrlcustomer}/releaseRequest/pdfDetails`,
    THIRD_PARTY_DOCUMENTS_List_BY_ID: `${baseUrlcustomer}/thirdpartydocument/list`,
    RESIDENTIAL_ADDRESS_UPDATE : `${baseUrl}/externalUser/update`,
    GET_RELEASE_RATE: `${baseUrlcustomer}/getRelease/request`,
    SKIP_MARGIN_PAYMENT: `${baseUrlcustomer}/isSkipMarginPayment/create`,
    RELEASE_REQUEST_COMPLETED_VIEW_DETAILS: `${baseUrlcustomer}/releaseRequest/viewDetails`,
    CUSTOMER_PROFILE_COMPLETED_LIST_NEW: `${baseUrl}/profile_completed/list`
  },

  business: {
    Business_customer_list: `${baseUrl}/users/list`,
    SAVED_DRAFT_LIST: `${baseUrl}/users/saveDraftList`,
    BUISNESS_DRAFT_CREATE: `${baseUrlcustomer}/contract/tempCreate`,
    BUISNESS_DRAFT_GET: `${baseUrlcustomer}/contract/tempContractget`,
  },

  teamMembers: {
    CREATE_MEMBER: `${baseUrl}/teamMember/create`,
    LIST_MEMBER: `${baseUrl}/teamMember/list`,
    VIEW_MEMBER: `${baseUrl}/teamMember/get`,
    UPDATE_MEMBER: `${baseUrl}/teamMember/update`,
    DELETE_MEMBER: `${baseUrl}/teamMember/delete`,
    LIST_ROLE: `${baseUrl}/role/list`,
  },
  areaManagerProposals: {
    AREAMANAGER_PROPOSALSLIST: `${baseUrlcustomer}/proposals/list`,
    AREAMANAGER_SUBMIT_REQUEST: `${baseUrlcustomer}/AreaManager-contract/list`,
    AREAMANAGER_APPROVEREQUEST: `${baseUrlcustomer}/AreaManager-contract/approveRequest`,
    AREAMANAGER_PROPOSALSUBMIT: `${baseUrlcustomer}/proposals/create`,
    AREAMANAGER_GET_PROPOSAL: `${baseUrlcustomer}/proposals/recentPending`,
    AREAMANAGER_GET_LAST_PROPOSAL: `${baseUrlcustomer}/proposals/lastBefore?`,
    QUALITYDETAILS: `${baseUrlcustomer}/qualityDetails/update`,
    AREAMANAGER_GET_CONTRACT: `${baseUrlcustomer}/contract/get`,
    QUALITYDETAILS_GETid: `${baseUrlcustomer}/qualityDetails/get`,
    REQUEST_NEW_WAREHOUSE: `${baseUrlWarehouse}/requestWarehouse/create`,
    REQUEST_NEW_WSP: `${baseUrl}/requestVendor/create`,
  },
  upload: {
    FILE_UPLOAD: `${baseUrl}/image/upload`,
  },

  onBoardsListSuperAdmin: {
    commodity_list: `${baseUrl}/commodity/list`,
    //location_list: `${baseUrl}/location/list`,
    commodity_delete: `${baseUrl}/commodity/delete`,
    location_delete: `${baseUrl}/location/delete`,
    customer_delete: `${baseUrl}/users/delete`,
    location_Create: `${baseUrl}/location/create`,
    location_view: `${baseUrl}/location/get`,
    cutomer_view: `${baseUrl}/users/getProfile`,
    GET_LAST_COMMODITY: `${baseUrl}/commodity/get/draft`,
    GET_LAST_VARIETY: `${baseUrl}/variety/get/draft`,
  },

  common: {
    PROFILE_PERCENTAGE: `${baseUrl}/user/profilePercent`,
    UPDATE_PROFILE: `${baseUrl}/user/updateProfile`,
    GET_PROFILE: `${baseUrl}/users/getProfile`,
    DELETE_ACCOUNT: `${baseUrl}/users/delete`,
  },

  location: {
    GET_CITY_STATE: `${baseUrlLocation}/pincode/list`,
  },
  notification: {
    NOTIFICATION_LIST: `${baseUrlNotification}/notification/list`,
    NOTIFICATION_UPDATE: `${baseUrlNotification}/notification/update`,
  },

  cog: {
    PO_UPDATE: `${baseUrlcustomer}/purchaseOrder/update`,
    VCM_PROPOSAL_LIST: `${baseUrlcustomer}/cogVcm/vcmProposalList`,
    VCM_CCNDITIONAL_List: `${baseUrlcustomer}/cogVcm/vcmConditional`,
    VIEW_PROPOSAL: `${baseUrlcustomer}/cogVcm/viewProposal`,
    DOCUMENT_STATUS: `${baseUrlcustomer}/cogVcm/updateDocumentStatus`,
    DOCUMENT_UPDATE: `${baseUrlcustomer}/cogVcm/updateDocument`,
    COUNTER_PROPOSAL: `${baseUrlcustomer}/cogVcm/counterProposal`,
    APPROVE_COG: `${baseUrlcustomer}/cogVcm/contractApproval`,
    APPROVE_COG_NEW: `${baseUrlcustomer}/cogVcm/contentApproval`,
    REJECT_CONTENT_APPROVE: `${baseUrlcustomer}/cogVcm/contentApproval`,
    GET_PROPOSAL_BY_ID: `${baseUrlcustomer}/proposals/get`,
    UPDATE_PROPOSALS: `${baseUrlcustomer}/proposals/update`,
    CREATE_BIDDING: `${baseUrlcustomer}/biddings/create`,
    UPDATE_BIDDING: `${baseUrlLocation}/biddings/update`,
    GET_BIDDING: `${baseUrlcustomer}/biddings/get`,
    LIST_BIDDING: `${baseUrlcustomer}/biddings/list`,
    LIST_BIDDING_STORAGE: `${baseUrlLocation}/biddings/storage/list`,
    LIST_NEW_PURCHASE_REQUEST: `${baseUrlcustomer}/purchaseOrder/list`,
    GET_ADDENDUM: `${baseUrlcustomer}/addendum/list`,
    APPROVE_DENY_ADDENDUM: `${baseUrlcustomer}/addendum/COG/addedumStatusUpdate`,

    LIST_COMPARATIVE_SHEET: `${baseUrlcustomer}/biddings/compList`,
    LIST_BID_DETAILS: `${baseUrlcustomer}/biddings/bidDetailsList`,
    //SEND_REMINDER_INPROGRESS: `${baseUrlcustomer}/biddings/sendReminder`,
    LIST_COMPARATIVE_MATCH_REQUEST: `${baseUrlLocation}/biddings/matchRequestList`,
    LIST_COMPARATIVE_FINILIAZED: `${baseUrlLocation}/biddings/finalizedList`,
    GET_BID_HISTORY: `${baseUrlcustomer}/biddings/supplierHistory`,
    REMIND_TO_SUBMIT_BID: `${baseUrlcustomer}/biddings/sendReminder`,
    REQUEST_TO_PURCHASE_CONFIRM: `${baseUrlcustomer}/biddings/requestCustomer`,
    CONTRACT_UPDATE: `${baseUrlcustomer}/contract/update`,
    SEND_REMINDER: `${baseUrlcustomer}/biddings/remindSubmitBid`,
    SUPPLIER_BY_PURCHASE: `${baseUrlcustomer}/biddings/suppliersByPurchase`,
    FINALIZED_SUPPLIER: `${baseUrlcustomer}/biddings/listFinalSupplier`,
    REVISED_PROPOSAL: `${baseUrlcustomer}/cog/proposals/list`,
    LIST_DEPOSIT_UPDATES: `${baseUrlcustomer}/depositUpdates/list`,
    LIST_DEPOSIT_UPDATES_STORAGE: `${baseUrlcustomer}/customer/depositUpdates/list`,
    GET_DEPOSIT_UPDATES: `${baseUrlcustomer}/depositUpdates/get`,
    DELETE_DEPOSIT_UPDATES: `${baseUrlcustomer}/depositUpdates/delete`,
    EDIT_DEPOSIT_UPDATES: `${baseUrlcustomer}/depositUpdates/update`,
    COG_APPROVED_PROPOSALS: `${baseUrlcustomer}/cogVcm/acceptedProposal`,
    AGREEMENT_FLOW_LIST: `${baseUrlcustomer}/contract/ccApprovalsList`,
    AGREEMENT_CLAUSE_LIST: `${baseUrlcustomer}/agreementTemplate/list`,
    GET_AGREEMENT_CLAUSE_BY_ID: `${baseUrlcustomer}/agreementTemplate/get`,
    POST_COG_APPROVAL_CCMEMBER: `${baseUrlcustomer}/cogVcm/contentApproval`,
    ADD_CC_MEMBER: `${baseUrlcustomer}/contract/ccMembers`,
    CONTENT_APPROVE: `${baseUrlcustomer}/cog/contentApprove`,
    DOWNLOAD_EXCEL: `${baseUrlcustomer}/contract/exportAgreement`,
    REJECT_AGREEMENT: `${baseUrlCog}/amentContent/RejectRequest`
  },

  dashboard: {
    YOUR_ACTIVITY_STATUS: `${baseUrlcustomer}/contract/contractStatus`,
    YOUR_ACTIVITY_PROGRESS: `${baseUrlcustomer}/contract/viewContractStatus`,
  },

  vcm: {
    GET_SUBMITTED_REQUESTS: `${baseUrlcustomer}/contract/list`,
    VIEW_SUBMITTED_REQUESTS: `${baseUrlcustomer}/contract/get`,
    DELETE_SUBMITTED_REQUESTS: `${baseUrlcustomer}/contract/delete`,
    COUNTER_PROPOSAL: `${baseUrlcustomer}/cogVcm/counterProposal`,
    VIEW_PROPOSAL: `${baseUrlcustomer}/cogVcm/viewProposal`,
  },

  cogOnboarding: {
    //Variety API
    GET_ALL_VARIETY_LIST: `${baseUrl}/variety/list`,
    GET_VARIETY_BY_ID: `${baseUrl}/variety/get`,
    CREATE_VARIETY: `${baseUrl}/variety/create`,
    UPDATE_VARIETY: `${baseUrl}/variety/update`,
    DELETE_VARIETY: `${baseUrl}/variety/delete`,
    //Commodity API
    GET_ALL_MAP_COMMODITY: `${baseUrl}/commodities/list`,
    GET_ALL_COMMODITY_LIST: `${baseUrl}/commodity/list`,
    GET_COMMODITY_BY_ID: `${baseUrl}/commodity/get`,
    DELETE_COMMODITY: `${baseUrl}/commodity/delete`,
    CREATE_COMMODITY: `${baseUrl}/commodity/create`,
    UPDATE_COMMODITY: `${baseUrl}/commodity/update`,
    //Location-Zone API
    GET_LOCATION_LIST: `${baseUrl}/locations/list`,
    GET_ALL_ZONE_LIST: `${baseUrl}/zone/list`,
    GET_ZONE_BY_ID: `${baseUrl}/zone/get`,
    CREATE_ZONE: `${baseUrl}/zone/create`,
    UPDATE_ZONE: `${baseUrl}/zone/update`,
    DELETE_ZONE: `${baseUrl}/zone/delete`,
    //Location-State API
    GET_ALL_STATE_LIST: `${baseUrl}/state/list`,
    GET_STATE_BY_ID: `${baseUrl}/state/get`,
    CREATE_STATE: `${baseUrl}/state/create`,
    UPDATE_STATE: `${baseUrl}/state/update`,
    DELETE_STATE: `${baseUrl}/state/delete`,
    //Location-District API
    GET_ALL_DISTRICT_LIST: `${baseUrl}/district/list`,
    GET_DISTRICT_BY_ID: `${baseUrl}/district/get`,
    CREATE_DISTRICT: `${baseUrl}/district/create`,
    UPDATE_DISTRICT: `${baseUrl}/district/update`,
    DELETE_DISTRICT: `${baseUrl}/district/delete`,
    // Location Api
    GET_ALL_Location_LIST: `${baseUrl}/locations/list`,
    GET_Location_BY_ID: `${baseUrl}/location/get`,
    CREATE_Location: `${baseUrl}/location/create`,
    UPDATE_Location: `${baseUrl}/location/update`,
    DELETE_Location: `${baseUrl}/location/delete`,
    // cluster Api
    GET_ALL_cluster_LIST: `${baseUrl}/cluster/list`,
    GET_cluster_BY_ID: `${baseUrl}/cluster/get`,
    CREATE_cluster: `${baseUrl}/cluster/create`,
    UPDATE_cluster: `${baseUrl}/cluster/update`,
    DELETE_cluster: `${baseUrl}/cluster/delete`,
    // Area Api
    GET_area_BY_ID: `${baseUrl}/area/get`,
    CREATE_area: `${baseUrl}/area/create`,
    UPDATE_area: `${baseUrl}/area/update`,
    DELETE_area: `${baseUrl}/area/delete`,
    GET_ALL_AREA_LIST: `${baseUrl}/area/list`,
    //Vendor API
    GET_ALL_VENDOR_LIST: `${baseUrl}/vendor/list`,
    // filter api
    GET_ALL_VENDOR: `${baseUrl}/vendors/list`,
    GET_VENDOR_BY_ID: `${baseUrl}/vendor/get`,
    VENDOR_ISEXIST: `${baseUrl}/vendor_get/get`,
    CREATE_VENDOR: `${baseUrl}/vendor/create`,
    UPDATE_VENDOR: `${baseUrl}/vendor/update`,
    DELETE_VENDOR: `${baseUrl}/vendor/delete`,
    //Warehouse API
    GET_ALL_WAREHOUSE_LIST: `${baseUrlWarehouse}/warehouse/list`,
    GET_WAREHOUSE_BY_ID: `${baseUrlWarehouse}/warehouse/get`,
    CREATE_WAREHOUSE: `${baseUrlWarehouse}/warehouse/create`,
    UPDATE_WAREHOUSE: `${baseUrlWarehouse}/warehouse/update`,
    DELETE_WAREHOUSE: `${baseUrlWarehouse}/warehouse/delete`,
  },

  GraiManager: {
    GET_TRUCK_BY_ID: `${baseUrlcustomer}/truckDetails/get`,
    // GET_TRUCK_BY_UNIQUECODE: `${baseUrlcustomer}/truckDetails/get`,
    GET_TRUCK_BY_TRUCKDETAILSLIST: `${baseUrlcustomer}/depositUpdates/list`,
    UPDATE_WEIGHBRIDGEDETAILS: `${baseUrlcustomer}/truckDetails/updateWeighbridgeDetails`,
    CREATE_QUALITY_CHECK: `${baseUrlcustomer}/qualityCheck/create`,
    CREATE_GSL_DETAILS: `${baseUrlcustomer}/gslDetails/create`,
    CREATE_DEPOSIT_UPDATE: `${baseUrlcustomer}/depositUpdates/create`,
    CREATE_DETAILS: `${baseUrlcustomer}/qualityDetails/create`,
    UPDATE_DEPOSIT_DETAILS: `${baseUrlcustomer}/depositUpdates/update`,
    GET_DEPOSIT_UPDATE: `${baseUrlcustomer}/depositUpdates/get`,
    GET_ALL_VENDOR_LIST: `${baseUrl}/vendor/list`,
    GET_RELEASE_MODULE_LIST: `${baseUrlcustomer}/releaseUpdate/list`,
    GET_RELEASE_BY_ID: `${baseUrlcustomer}/releaseUpdate/get`,
    UPDATE_RELEASE_MODULE: `${baseUrlcustomer}/releaseUpdate/update`,
    UPDATE_RELEASE_MODULE_NEW: `${baseUrlcustomer}/commodityWithdrawal/form`,
    UPDATE_RELEASE_INVOICE: `${baseUrlcustomer}/invoice/view`,
    UPDATE_TRUCK_DETAILS: `${baseUrlcustomer}/releaseOrder/get`,
    UPDATE_TRUCK_INVOICE_DETAILS: `${baseUrlcustomer}/releaseUpdate/get`,
    GET_LOT_NUMBER: `${baseUrlcustomer}/lotNumber/get`,
    GET_GO_DOWN_NUMBER: `${baseUrlWarehouse}/warehouse/get`,
    GET_WEIGHTMENT: `${baseUrlcustomer}/weightment/get`,
    GET_QR_PENDING : `${baseUrlcustomer}/agentCommodityDeposit/supplierBiddingsDataList/list`,
    POST_OTP_DIGITALSIGN : `${baseUrl}/grainManager/authorizedPerson/sendOtp`,
    TRUCK_NEW_GET_API : `${baseUrlcustomer}/commodityRelease/get`
  },

  QualityManager: {
    UPLOAD_EXCELSHEET: `${baseUrlcustomer}/depositUpdates/sheetUpdate`,
  },
  finance: {
    DEPOSIT_LIST: `${baseUrlcustomer}/purchaseOrder/payment/list`,
    DEPOSIT_UPDATE: `${baseUrlcustomer}/purchaseOrder/payment/update`,
    DEPOSIT_UPDATE_NEW: `${baseUrlcustomer}/releaseRequest/update`,
    INVOICE_LIST: `${baseUrlcustomer}/releaseUpdate/financeTeamList`,
    INVOICE_UPDATE: `${baseUrlcustomer}/releaseUpdate/financeTeam/statusUpdate`,
  },
  purchase: {
    GET_ALL_PURCHASE_ORDER_LIST: `${baseUrlcustomer}/purchaseOrder/list`,
    CREATE_PURCHASE_REQUEST: `${baseUrlcustomer}/purchaseOrder/create`,
    OFFLINE_PAYMENT_REQUEST: `${baseUrlPayment}/releasePurchaseOrderOfflinePayment`,
    OFFLINE_PAYMENT_FIRM: `${baseUrlPayment}/purchaseOrderOfflinePayment`,
    GET_BY_ID_PURCHASE_ORDER: `${baseUrlcustomer}/purchaseOrder/finalSuppliersByPurchaseId`,
  },

  supplier: {
    BID_REQUEST_LIST: `${baseUrlLocation}/biddings/bidRequestList`,
    CREATE_BID: `${baseUrlLocation}/biddings/create`,
    BID_SUBMITTED_LIST: `${baseUrlLocation}/biddings/list`,
    MATCH_SUPPLIER_REQUEST: `${baseUrlLocation}/biddings/negotiateBid`,
    REJECT_SUPPLIER_BID_REQUEST: `${baseUrlLocation}/biddings/rejectBid`,
    SUPPLIER_PURCHASE_ORDER: `${baseUrlLocation}/supplierPurchaseOrder/list`,
    GET_PURCHASE_ORDER_BY_ID: `${baseUrlLocation}/biddings/get`,
    COMMODITY_DEPOSIT_CREATE: `${baseUrlcustomer}/commodityDeposit/create`,
    GET_CONCLUDE_TRANSITION: `${baseUrlcustomer}/depositUpdates/concludeTransaction`,
    COMMODITY_DEPOSIT_CREATE_BY_AGENT: `${baseUrlcustomer}/agentCommodityDeposit/create`,
    VENDOR_AUTHORIZED_CREATE : `${baseUrl}/vendorAuthorizedPerson/create`,
    VENDOR_AUTHORIZED_LIST : `${baseUrl}/vendorAuthorizedPerson/list`,
  },
  agent: {
    LIST_AGENT: `${baseUrl}/agent/list`,
    CREATE_AGENT: `${baseUrl}/agent/create`,
    SUPPLIER_PURCHASE_ORDER_AGENT: `${baseUrlcustomer}/agentCommodityDeposit/list`,
    BIDDING_UPDATE_AGENT : `${baseUrlcustomer}/agentCommodityDeposit/update`,
    GET_AGENT: `${baseUrlcustomer}/agentCommodityDeposit/get`,
    GET_BANK_NAME_LIST: `${baseUrl}/bank/list`
  },

};
